export default __webpack_public_path__ + "static/media/guests.b07b4f6c.svg";